import { GuidedTour } from '@talend/react-containers';

export const TDC_GUIDED_TOUR_INITIALIZE = 'TDC_GUIDED_TOUR_INITIALIZE';
export const TDC_GUIDED_TOUR_SHOW = 'TDC_GUIDED_TOUR_SHOW';

export function initializeGuidedTour(): { type: string } {
	return {
		type: TDC_GUIDED_TOUR_INITIALIZE,
	};
}

export function showGuidedTour(): { type: string } {
	return {
		type: TDC_GUIDED_TOUR_SHOW,
	};
}


export function showGuidedTourHome(): { type: string } {
	return {
		type: GuidedTour.constants.GUIDED_TOUR_SHOW,
	};
}

export function closeGuidedTourHome(): { type: string } {
	return {
		type: GuidedTour.constants.GUIDED_TOUR_HIDE,
	};
}

export default {
	'tdc:showGuidedTour': showGuidedTour,
};
